import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, Inject, Input, OnDestroy, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';

import { CreateStyleProvider, CREATE_STYLE } from '@finder/shared/utils/dom/createStyle';
import { OverlayElement } from './overlay-element.interface';

@Directive({
    selector: '[finderOverlayElement]',
    standalone: true
})
export class OverlayElementDirective implements AfterViewInit, OnDestroy {
    private overlay: OverlayElement;
    private resizeObserver;
    private destroy$ = new Subject<void>();

    @Input()
    set finderOverlayElement(data: OverlayElement) {
        this.overlay = data;
    }

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document,
        @Inject(CREATE_STYLE) private createStyle: CreateStyleProvider,
    ) {}

    ngAfterViewInit() {
        const desktop = this.overlay?.desktop;
        const mobile = this.overlay?.mobile;

        /* istanbul ignore if */
        if (!desktop) {
            return;
        }

        const el = this.elementRef.nativeElement;

        /* istanbul ignore else */
        if (desktop !== 'true') {
            el.style.setProperty('--overlay-margin-top', desktop);
        }

        // Create the styling
        let css = `
.overlay {
    position: absolute !important;
    margin-top: var(--overlay-margin-top, -50px);
    z-index: var(--overlay-z-index, 1);
    width: var(--overlay-width, 100%);
}
.overlay .partial-bg { display: none; }
`;
        if (mobile) {
            css += `
@media(max-width: 767px) {
    .overlay {
        --overlay-margin-top: ${ mobile === 'true' ? '-175px' : mobile };
    }
}
`;
        }
        // Add the CSS to the document
        this.createStyle(this.document, css, 'overlay');

        // Add class to element
        this.renderer.addClass(el, 'overlay');
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();

        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }
}
